export const ConfigData = [
  {
    id: "sk",
    name: "Type",
    isShow: true,
    width: "400px",
    filter: true,
  },
  {
    id: "threshold",
    name: "Max absence/cancelled",
    isShow: true,
    width: "250px",
    filter: true,
  },
  {
    id: "period",
    name: "Period",
    isShow: true,
    width: "150px",
    filter: true,
  },
  {
    id: "status",
    name: "Status",
    isShow: true,
    width: "150px",
    filter: true,
  },
  {
    id: "button",
    name: "Action",
    type: "dropdown",
    isShow: true,
    width: "117px",
    action: ["View Details", "Update Status"],
    permission: {
      ["View Details"]: {
        id: "View Details",
        permission: ["bus_booking.access_suspension_config"]

      },
      ["Update Status"]: {
        id: "Update Status",
        permission: ["bus_booking.update_suspension_config"]
      }
    },
  },
];
